import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import courses from "../Navigation_Bar/sidebar-data";




const SingleCourse = () => {
  const { id } = useParams();
  const [course, setCourses] = useState(null);
  

  useEffect(() => {
    setCourses(courses);
  }, []);



  return (
    <>
      <div style={{ position: "absolute", top: "10rem", color: "red" }}>
   
        <h2>First course</h2>
        <Link to="/" >back home</Link>
      </div>
    </>
  );
};

export default SingleCourse;
